import request, { ResponseData } from '@/utils/request'
import { OssInfoType, UserResult } from '@/models/global'

// 获取客户信息
export async function fetchEmployees(params): Promise<ResponseData<UserResult>> {
  return request('/api/v1/users/list', {
    method: 'post',
    data: params,
  })
}

// 获取oss上传信息
export async function fetchOssToken(): Promise<ResponseData<OssInfoType>> {
  return request('/api/v1/sys/oss/tsc', {
    method: 'post',
  })
}

// 获取免费时使用的流量
export async function fetchData(): Promise<ResponseData<UserResult>> {
  return request('/api/v1/users/his_traffic', {
    method: 'post',
  })
}

// 任务查询
export async function fetchTaskList(params): Promise<ResponseData<UserResult>> {
  return request('/api/v1/task/list', {
    method: 'post',
    data: params,
  })
}

// 聊天图片解析
export async function fetchImgParse(params) {
  return request('/api/v1/sys/llm/parse_url', {
    method: 'post',
    data: params,
  })
}
